// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__32Isv","addWidgetButton":"Header_addWidgetButton__jUiIh","dashboardTabs":"Header_dashboardTabs__2XEpf","active":"Header_active__1Abee"};